import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

interface IStyleProps {
  xClickPosition: number;
  yClickPosition: number;
}

export const Root = styled.div`
  z-index: 1000;
  width: 858px;
  padding: 54px 41px 50px 41px;
  box-shadow: -2px 4px 30px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: absolute;
  top: ${(props: IStyleProps) => (props.yClickPosition - 160)}px;
  left: ${(props: IStyleProps) => (props.xClickPosition - 980)}px;
`;

export const Message = styled.div`
  font-family: Rubik;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;

export const CodeBox = styled.div`
  width: 100%;
  border-radius: 20px;
  border: solid 1px rgba(189, 189, 189, 0.5);
  margin: 25px 0px 0px 0px;
  display: flex;
  flex-direction: row;
`;

export const HtmlText = styled.div`
  width: 85%;
  padding: 26px 29px 26px 29px;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  white-space: pre-line;
`;

export const CopyOuterContainer = styled.div`
  padding: 7px 7px 0px 0px;
`;

export const CopyContainer = styled.div`
  cursor: pointer;
  border-radius: 50%;
  width: 57px;
  height: 55px;
  padding: 7px 0px 0px 5px;
  background: none;
  &:hover {
      background-color: rgba(18, 36, 66, 0.05);
  }
`;
